import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';


class EndeksListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EndeksListe";
    super(baseUrl);
  }


  getEndeksListe(sicilKodu: number,aboneNo?: number){
    
        var request= new EndeksRequest(sicilKodu,aboneNo);
    return this.post("", request, false);
   
  }

}
export default new EndeksListeAPI();
class EndeksRequest {
  public sicilKodu: number;
  public aboneNo?: number;
  constructor(sicilKodu: number,aboneNo?: number) {
   
      this.sicilKodu = sicilKodu;
      this.aboneNo = aboneNo;

  }
}
export { EndeksRequest };